// IDs de país tal como los devuelve la API (campo `pais.id` de la empresa).
// Vive acá y no en `CountryContext` para romper el ciclo de imports
// CountryContext -> UserContext -> CountryContext (regla P5 de AGENTS.md):
// `UserContext` necesita la constante pero no debe depender del contexto de país.
// Ojo: no confundir con `selectedCountryId` del CountryContext, que es un flag
// booleano-like mapeado a 0 (Argentina) / 1 (Brasil).
export const COUNTRY = {
  ARGENTINA: 1,
  BRASIL: 3,
};
